"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REGEXP_NON_PHONE_SYMBOLS = exports.REGEXP_IS_RUSSIAN_NUMBER = void 0;
exports.REGEXP_IS_RUSSIAN_NUMBER = /^(\+?7|8)9(\d{9})$/;
exports.REGEXP_NON_PHONE_SYMBOLS = /[^\d+()]/g;
//# sourceMappingURL=phone-number.regexp.js.map